import authServiceInstance from "../../../../service/auth.service";

export const handleRegister = (formState) => {
  const newUser = {
    email: formState.email,
    password: formState.password,
    firstName: formState.firstName,
    lastName: formState.lastName,
    abbreviation: formState.abbreviation,
    schools: formState.schools,
  };

  return authServiceInstance.register(newUser);
};
